import { useState } from 'react';
import Home from './Home.jsx';
import Team from './Team.jsx';
import Admin from './Admin.jsx';

// tab nav ล่าง — Home / Team (+ Admin ถ้าเป็น HR) · เก็บ char state ที่นี่ให้คงอยู่ข้ามแท็บ
export default function Shell({ auth, initialState }) {
  const [tab, setTab] = useState('home');
  const [char, setChar] = useState(initialState.chosenChar || 'king');
  const isHr = !!initialState.isHr;

  return (
    <>
      <div className="shell">
        {tab === 'home' && <Home auth={auth} initialState={initialState} char={char} onCharChange={setChar} />}
        {tab === 'team' && <Team auth={auth} char={char} />}
        {tab === 'admin' && <Admin auth={auth} />}
      </div>
      <nav className="tabbar">
        <button className={tab === 'home' ? 'active' : ''} onClick={() => setTab('home')}>
          <img src="/assets/ui/portrait.png" alt="" />หน้าหลัก
        </button>
        <button className={tab === 'team' ? 'active' : ''} onClick={() => setTab('team')}>
          <img src="/assets/ui/map.png" alt="" />แผนที่ทีม
        </button>
        {isHr && (
          <button className={tab === 'admin' ? 'active' : ''} onClick={() => setTab('admin')}>
            <img src="/assets/ui/gear.png" alt="" />แอดมิน
          </button>
        )}
      </nav>
    </>
  );
}
